import { render } from "./instructor-withdraw-modal.vue?vue&type=template&id=f0c98ffc"
const script = {}

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__